import {
  PaletteTonalOffset,
  TypeDivider,
  PaletteAugmentColorOptions
} from '@mui/material/styles/createPalette';
import {
  CommonColors,
  PaletteMode,
  Color,
  TypeText,
  TypeAction,
  TypeBackground
} from '@mui/material';
declare module '@mui/material/styles/createPalette' {
  interface Palette {
    base: Palette['primary'];
    grayBackground: Palette['primary'];
    textColor: Palette['primary'];
  }
  interface PaletteOptions {
    base: PaletteOptions['primary'];
    grayBackground: PaletteOptions['primary'];
    textColor: PaletteOptions['primary'];
  }

  interface PaletteColor {
    A100?: string;
    A90?: string;
    A80?: string;
    A70?: string;
    A60?: string;
    A50?: string;
    A40?: string;
    A30?: string;
    A20?: string;
    A10?: string;
    A0?: string;
  }
  interface SimplePaletteColorOptions {
    A100?: string;
    A90?: string;
    A80?: string;
    A70?: string;
    A60?: string;
    A50?: string;
    A40?: string;
    A30?: string;
    A20?: string;
    A10?: string;
    A0?: string;
  }
}
export interface PaletteColor {
  light: string;
  main: string;
  dark: string;
  contrastText: string;
  A100?: string;
  A90?: string;
  A80?: string;
  A70?: string;
  A60?: string;
  A50?: string;
  A40?: string;
  A30?: string;
  A20?: string;
  A10?: string;
  A0?: string;
}

export interface Palette {
  common: CommonColors;
  mode: PaletteMode;
  contrastThreshold: number;
  tonalOffset: PaletteTonalOffset;
  primary: PaletteColor;
  secondary: PaletteColor;
  error: PaletteColor;
  warning: PaletteColor;
  info: PaletteColor;
  success: PaletteColor;
  base: PaletteColor;
  grayBackground: PaletteColor;
  textColor: PaletteColor;
  grey: Color;
  text: TypeText;
  divider: TypeDivider;
  action: TypeAction;
  background: TypeBackground;
  getContrastText: (background: string) => string;
  augmentColor: (options: PaletteAugmentColorOptions) => PaletteColor;
}

export default {};
